import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect';
import FormTextArea from '../../../../antd/form/FormTextArea/FormTextArea';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import FormButton from '../../../../antd/form/FormButton/FormButton';
import { required } from '../../../../antd/form/FormValidation';
import { CollapseBlock } from '../../../../common';
import PhdHelpHint from '../../../../common/Phd/PhdHelpHint.jsx';

const PhdCommentsForm = ({ thesisOptions, isEdit, isSubmitting }) => {
  const { t } = useTranslation();

  return (
    <>
      <CollapseBlock collapsible title={t('Základné informácie')}>
        <Row gutter={16}>
          <Col span={12}>
            <FormSelect
              name="phd_thesis_id"
              label={
                <span>
                  {t('Téma')}
                  <PhdHelpHint
                    label={t('Ktorú tému možno pripomienkovať?')}
                    title={t(
                      'Zobrazia sa iba nepublikované témy dostupné podľa vašej roly, vlastníctva alebo odboru pracovnej skupiny.',
                    )}
                  />
                </span>
              }
              options={thesisOptions}
              rules={[required(t)]}
              disabled={isEdit}
            />
          </Col>
        </Row>
        <FormTextArea
          name="text"
          label={t('Text komentára')}
          rows={6}
          rules={[required(t)]}
        />
      </CollapseBlock>
      <FormButtonsContainer>
        <FormButton
          submitOnClick
          submitKey="phd-comments"
          disabled={isSubmitting}
        >
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </>
  );
};

PhdCommentsForm.propTypes = {
  thesisOptions: PropTypes.array,
  isEdit: PropTypes.bool,
  isSubmitting: PropTypes.bool,
};

export default PhdCommentsForm;
